import {LeaderboardDto} from "../../../models/dtos/leaderboard.dto";
import axios from "../../../utilities/axios";

export const getLeaderboardRequest = async (): Promise<LeaderboardDto> => {
  try {
    const response = await axios.get<LeaderboardDto>(
      `${process.env.REACT_APP_BASE_URL}/users/scoreboard`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
